(function () {
    'use strict';

    angular
        .module('bcmModule')
        .directive('bcmBiaProfile', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);

        directiveScope.editAction = '&';
        directiveScope.hideActions = '=';
        directiveScope.highlight = '=';
        directiveScope.canValidate = '=';
        directiveScope.canReject = '=';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$scope', '$controller',
                function ($scope, $controller) {

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/BCM/BIAProfile/bcmBiaProfile.[Template].tpl.html';

                    // Permissions default values
                    $scope.boxFeatureRole = $scope.boxFeatureRole || 'BCMManagement';
                    $scope.boxPermissionKey = $scope.boxPermissionKey || 'BIAProfile';

                    // Wait for link to calculate withActions
                    var unwatch = $scope.$watch('withActions', function (withActions) {
                        $scope.withActions = withActions && !$scope.hideActions;
                        unwatch();
                    });

                    $scope.ctrlCtxt = {
                        needsBCCValidation: _.get($scope, 'boxModel.NextItemTaskDefinition.Value') === 'NeedBCCValidation'
                    };

                    // Format MTPD minutes to display string
                    $scope.formatMtpd = function (val) {
                        if (val == null) return null;
                        var h = Math.floor(val / 60);
                        var m = val % 60;
                        if (h > 0 && m > 0) return h + 'h ' + m + 'm';
                        if (h > 0) return h + 'h';
                        return m + 'm';
                    };

                    $controller('BoxTmplController', { $scope: $scope });
                }
            ],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);

                scope.withActions = !_.isUndefined(attrs.editAction);
            }
        };
    }
})();
